import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { cicPath } from '@shared/utils/category.util';

/**
 * A service-category glyph rendered as a real `<svg><path>`. Replaces the
 * mockup's `'<svg…>' + cic(code) + '</svg>'` string injection everywhere it appeared. Each
 * category icon is a single path (see `CATICON`), so `cicPath(code)` supplies the whole `d`.
 */
@Component({
  selector: 'app-cat-icon',
  standalone: true,
  templateUrl: './cat-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CatIconComponent {
  /** Category code (mockup `cic` key). Unknown codes fall back to a generic grid glyph. */
  @Input() code = '';
  /** Square px size for width/height. */
  @Input() size: number | string = 18;
  /** SVG fill — a colour, or `currentColor` to inherit. */
  @Input() fill = 'currentColor';

  get path(): string { return cicPath(this.code); }
}
